import { render, staticRenderFns } from "./HekimListesi.vue?vue&type=template&id=48ea3f4c&scoped=true&"
import script from "./HekimListesi.vue?vue&type=script&lang=js&"
export * from "./HekimListesi.vue?vue&type=script&lang=js&"
import style0 from "./HekimListesi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HekimListesi.vue?vue&type=style&index=1&id=48ea3f4c&lang=scss&scoped=true&"
import style2 from "./HekimListesi.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea3f4c",
  null
  
)

export default component.exports